import { useMemo, useCallback } from 'react';
import { FiltersCounts } from '../types';
import { useDrawerContext } from '../context';

type UseDrawerFiltersCountsResult = {
  filtersCounts: FiltersCounts;
  handleFiltersCountsChange: (newFiltersCounts: FiltersCounts) => void;
};

const useDrawerFiltersCounts = (): UseDrawerFiltersCountsResult => {
  const { filtersCounts, setFiltersCounts } = useDrawerContext();

  const handleFiltersCountsChange = useCallback((newFiltersCounts: FiltersCounts): void => {
    setFiltersCounts(newFiltersCounts);
  }, []);

  return useMemo(
    () => ({
      filtersCounts,
      handleFiltersCountsChange,
    }),
    [filtersCounts, handleFiltersCountsChange]
  );
};

export default useDrawerFiltersCounts;
